export const anonymize = async (value: string): Promise<string> => {
  const encodedString = new TextEncoder().encode(value);
  const digest = await crypto.subtle.digest('SHA-512', encodedString);
  const firstByte = new Uint8Array(digest.slice(0, 1))[0];
  const anonymizedValue = firstByte.toString(16).padStart(2, '0');

  return anonymizedValue;
}
